module.exports = __webpack_public_path__ + "img/about-group-img4.765e44c9.png";